// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   FaBook,
//   FaSearch,
//   FaFilter,
//   FaSortAmountDown,
//   FaSortAmountUp,
//   FaPlus,
//   FaEye,
//   FaEdit,
//   FaTrash,
//   FaFilePdf,
//   FaGlobe,
//   FaRupeeSign,
//   FaTag,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaExternalLinkAlt,
//   FaGooglePlay,
//   FaChevronLeft,
//   FaChevronRight,
//   FaFileAlt,
//   FaList,
//   FaLanguage,
//   FaCalendar,
//   FaPercentage,
//   FaUserEdit,
//   FaImage,
//   FaTimes
// } from 'react-icons/fa';

// // Mock data for e-books
// const initialBooks = [
//   {
//     id: 1,
//     bookName: 'Complete Guide to Diabetes Care',
//     authorName: 'Dr. Niten Gathge',
//     coverImage: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=600&fit=crop',
//     languages: ['English', 'Marathi'],
//     totalPages: 220,
//     price: 299,
//     discount: 15,
//     finalPrice: 254.15,
//     bookType: 'Paid',
//     status: 'Active',
//     description: 'A comprehensive guide covering all aspects of diabetes management including diet, exercise, medication and lifestyle changes.',
//     tableOfContents: [
//       'Chapter 1: Understanding Diabetes',
//       'Chapter 2: Diagnosis and Monitoring',
//       'Chapter 3: Medication Guide',
//       'Chapter 4: Diet and Nutrition',
//       'Chapter 5: Exercise and Lifestyle'
//     ],
//     pdfFiles: {
//       english: 'diabetes_guide_english.pdf',
//       marathi: 'diabetes_guide_marathi.pdf'
//     },
//     playStoreLink: 'https://play.google.com/store/apps/details?id=com.diabetes.guide',
//     websiteLink: 'https://diabetescare.example.com',
//     createdAt: '2024-01-15'
//   },
//   {
//     id: 2,
//     bookName: 'Heart Health Handbook',
//     authorName: 'Dr. Priya Sharma',
//     coverImage: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=600&fit=crop',
//     languages: ['English', 'Hindi'],
//     totalPages: 180,
//     price: 0,
//     discount: 0,
//     finalPrice: 0,
//     bookType: 'Free',
//     status: 'Active',
//     description: 'Essential guide for maintaining heart health through diet, exercise and regular checkups.',
//     tableOfContents: [
//       'Chapter 1: Heart Anatomy and Function',
//       'Chapter 2: Common Heart Conditions',
//       'Chapter 3: Prevention Strategies',
//       'Chapter 4: Heart-Healthy Diet',
//       'Chapter 5: Exercise for Heart Health'
//     ],
//     pdfFiles: {
//       english: 'heart_health_english.pdf'
//     },
//     playStoreLink: '',
//     websiteLink: 'https://hearthealth.example.com',
//     createdAt: '2024-02-10'
//   },
//   {
//     id: 3,
//     bookName: 'Mental Wellness Guide',
//     authorName: 'Dr. Anil Verma',
//     coverImage: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=600&fit=crop',
//     languages: ['English', 'Hindi', 'Marathi'],
//     totalPages: 250,
//     price: 399,
//     discount: 20,
//     finalPrice: 319.2,
//     bookType: 'Paid',
//     status: 'Active',
//     description: 'Comprehensive guide to mental health, covering stress management, anxiety, depression and mindfulness techniques.',
//     tableOfContents: [
//       'Chapter 1: Understanding Mental Health',
//       'Chapter 2: Stress Management',
//       'Chapter 3: Anxiety and Depression',
//       'Chapter 4: Mindfulness Techniques',
//       'Chapter 5: Professional Help Guide'
//     ],
//     pdfFiles: {
//       english: 'mental_wellness_english.pdf',
//       hindi: 'mental_wellness_hindi.pdf',
//       marathi: 'mental_wellness_marathi.pdf'
//     },
//     playStoreLink: 'https://play.google.com/store/apps/details?id=com.mental.wellness',
//     websiteLink: 'https://mentalwellness.example.com',
//     createdAt: '2024-01-28'
//   },
//   {
//     id: 4,
//     bookName: 'Child Nutrition Basics',
//     authorName: 'Dr. Sunita Patel',
//     coverImage: 'https://images.unsplash.com/photo-1542736667-069246bdbc6d?w=400&h=600&fit=crop',
//     languages: ['English'],
//     totalPages: 150,
//     price: 199,
//     discount: 10,
//     finalPrice: 179.1,
//     bookType: 'Paid',
//     status: 'Inactive',
//     description: 'Essential nutrition guide for children from infancy to adolescence.',
//     tableOfContents: [
//       'Chapter 1: Nutrition for Infants',
//       'Chapter 2: Toddler Nutrition',
//       'Chapter 3: School Age Nutrition',
//       'Chapter 4: Healthy Eating Habits',
//       'Chapter 5: Dealing with Picky Eaters'
//     ],
//     pdfFiles: {
//       english: 'child_nutrition_english.pdf'
//     },
//     playStoreLink: '',
//     websiteLink: '',
//     createdAt: '2024-03-05'
//   },
//   {
//     id: 5,
//     bookName: 'Yoga for Everyday Health',
//     authorName: 'Dr. Rajesh Kumar',
//     coverImage: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=600&fit=crop',
//     languages: ['Hindi', 'Marathi'],
//     totalPages: 200,
//     price: 0,
//     discount: 0,
//     finalPrice: 0,
//     bookType: 'Free',
//     status: 'Active',
//     description: 'Daily yoga routines for maintaining physical and mental health.',
//     tableOfContents: [
//       'Chapter 1: Yoga Basics',
//       'Chapter 2: Morning Routines',
//       'Chapter 3: Office Yoga',
//       'Chapter 4: Stress Relief Poses',
//       'Chapter 5: Meditation Techniques'
//     ],
//     pdfFiles: {
//       hindi: 'yoga_hindi.pdf',
//       marathi: 'yoga_marathi.pdf'
//     },
//     playStoreLink: 'https://play.google.com/store/apps/details?id=com.yoga.health',
//     websiteLink: '',
//     createdAt: '2024-02-20'
//   }
// ];

// const AdminViewBook = () => {
//   const navigate = useNavigate();
//   const [books, setBooks] = useState(initialBooks);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [searchType, setSearchType] = useState('bookName');
//   const [filters, setFilters] = useState({
//     bookType: 'all',
//     language: 'all',
//     sortBy: 'latest'
//   });
//   const [viewDetails, setViewDetails] = useState(null);
//   const [deleteConfirm, setDeleteConfirm] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [successMessage, setSuccessMessage] = useState('');
//   const [errorMessage, setErrorMessage] = useState('');

//   const bookTypes = ['All', 'Free', 'Paid'];
//   const languages = ['All', 'English', 'Marathi', 'Hindi'];
//   const sortOptions = [
//     { value: 'latest', label: 'Latest' },
//     { value: 'price_low', label: 'Price: Low to High' },
//     { value: 'price_high', label: 'Price: High to Low' },
//     { value: 'name_asc', label: 'Name: A to Z' },
//     { value: 'name_desc', label: 'Name: Z to A' }
//   ];

//   // Filter and sort books
//   const filteredBooks = books.filter(book => {
//     // Search filter
//     if (searchQuery) {
//       if (searchType === 'bookName' && !book.bookName.toLowerCase().includes(searchQuery.toLowerCase())) {
//         return false;
//       }
//       if (searchType === 'authorName' && !book.authorName.toLowerCase().includes(searchQuery.toLowerCase())) {
//         return false;
//       }
//     }

//     // Book type filter
//     if (filters.bookType !== 'all' && book.bookType !== filters.bookType) {
//       return false;
//     }

//     // Language filter
//     if (filters.language !== 'all' && !book.languages.includes(filters.language)) {
//       return false;
//     }

//     return true;
//   }).sort((a, b) => {
//     // Sort logic
//     switch (filters.sortBy) {
//       case 'latest':
//         return new Date(b.createdAt) - new Date(a.createdAt);
//       case 'price_low':
//         return a.finalPrice - b.finalPrice;
//       case 'price_high':
//         return b.finalPrice - a.finalPrice;
//       case 'name_asc':
//         return a.bookName.localeCompare(b.bookName);
//       case 'name_desc':
//         return b.bookName.localeCompare(a.bookName);
//       default:
//         return 0;
//     }
//   });

//   // Pagination
//   const indexOfLastBook = currentPage * itemsPerPage;
//   const indexOfFirstBook = indexOfLastBook - itemsPerPage;
//   const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
//   const totalPages = Math.ceil(filteredBooks.length / itemsPerPage);

//   // Handle book deletion
//   const handleDeleteBook = (id) => {
//     setBooks(books.filter(book => book.id !== id));
//     setDeleteConfirm(null);
//     setSuccessMessage('E-Book deleted successfully!');
//     setTimeout(() => setSuccessMessage(''), 3000);
//   };

//   // Handle view details
//   const handleViewDetails = (book) => {
//     setViewDetails(book);
//   };

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Handle items per page change
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(parseInt(e.target.value));
//     setCurrentPage(1);
//   };

//   // Render pagination
//   const renderPagination = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between mt-6">
//         <div className="flex items-center space-x-4 mb-4 sm:mb-0">
//           <span className="text-sm text-gray-600">Show:</span>
//           <select
//             value={itemsPerPage}
//             onChange={handleItemsPerPageChange}
//             className="border border-gray-300 rounded-lg px-3 py-1 text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//           >
//             <option value="5">5</option>
//             <option value="10">10</option>
//             <option value="20">20</option>
//             <option value="50">50</option>
//           </select>
//           <span className="text-sm text-gray-600">items per page</span>
//         </div>
        
//         <div className="flex items-center space-x-2">
//           <button
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//             className="p-2 rounded-lg border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//           >
//             <FaChevronLeft />
//           </button>
          
//           {pageNumbers.map(number => (
//             <button
//               key={number}
//               onClick={() => handlePageChange(number)}
//               className={`w-10 h-10 rounded-lg flex items-center justify-center ${
//                 currentPage === number
//                   ? 'bg-teal-600 text-white'
//                   : 'border border-gray-300 hover:bg-gray-50'
//               }`}
//             >
//               {number}
//             </button>
//           ))}
          
//           <button
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//             className="p-2 rounded-lg border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//           >
//             <FaChevronRight />
//           </button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* 1️⃣ PAGE HEADER / TITLE */}
//         <div className="mb-8">
//           <nav className="flex text-sm text-gray-600 mb-4" aria-label="Breadcrumb">
//             <Link to="/admin/dashboard" className="hover:text-teal-600">Dashboard</Link>
//             <span className="mx-2">/</span>
//             <Link to="/admin/ebooks" className="hover:text-teal-600">Manage E-Books</Link>
//             <span className="mx-2">/</span>
//             <span className="text-gray-800 font-medium">View E-Books</span>
//           </nav>
          
//           <div className="flex flex-col sm:flex-row sm:items-center justify-between">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-800">View E-Books</h1>
//               <p className="text-gray-600 mt-2">
//                 Manage and view all e-books in your platform
//               </p>
//             </div>
            
//             <div className="mt-4 sm:mt-0">
//               <Link
//                 to="/admin/ebooks/add"
//                 className="inline-flex items-center px-5 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-medium rounded-xl hover:from-teal-700 hover:to-emerald-700 transition-all shadow-lg hover:shadow-xl"
//               >
//                 <FaPlus className="mr-2" />
//                 Add New E-Book
//               </Link>
//             </div>
//           </div>
//         </div>

//         {/* Success/Error Messages */}
//         {successMessage && (
//           <div className="mb-6 p-4 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl">
//             <div className="flex items-center">
//               <FaCheckCircle className="text-green-500 text-xl mr-3" />
//               <div>
//                 <p className="font-medium text-green-800">{successMessage}</p>
//               </div>
//             </div>
//           </div>
//         )}

//         {errorMessage && (
//           <div className="mb-6 p-4 bg-gradient-to-r from-red-50 to-pink-50 border border-red-200 rounded-xl">
//             <div className="flex items-center">
//               <FaTimesCircle className="text-red-500 text-xl mr-3" />
//               <div>
//                 <p className="font-medium text-red-800">{errorMessage}</p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 2️⃣ SEARCH AND FILTER BAR */}
//         <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
//           <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//             {/* Search Section */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 🔍 Search by:
//               </label>
//               <div className="flex space-x-2">
//                 <select
//                   value={searchType}
//                   onChange={(e) => setSearchType(e.target.value)}
//                   className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                 >
//                   <option value="bookName">Book Name</option>
//                   <option value="authorName">Author Name</option>
//                 </select>
//                 <div className="relative flex-1">
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FaSearch className="text-gray-400" />
//                   </div>
//                   <input
//                     type="text"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                     placeholder="Search..."
//                     className="pl-10 w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Filter by Book Type */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <FaFilter className="inline mr-1" /> Filter by Book Type
//               </label>
//               <select
//                 value={filters.bookType}
//                 onChange={(e) => setFilters({ ...filters, bookType: e.target.value })}
//                 className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//               >
//                 {bookTypes.map(type => (
//                   <option key={type} value={type.toLowerCase()}>{type}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Filter by Language */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <FaLanguage className="inline mr-1" /> Filter by Language
//               </label>
//               <select
//                 value={filters.language}
//                 onChange={(e) => setFilters({ ...filters, language: e.target.value })}
//                 className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//               >
//                 {languages.map(lang => (
//                   <option key={lang} value={lang.toLowerCase()}>{lang}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Sort by */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 <FaSortAmountDown className="inline mr-1" /> Sort by
//               </label>
//               <select
//                 value={filters.sortBy}
//                 onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}
//                 className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//               >
//                 {sortOptions.map(option => (
//                   <option key={option.value} value={option.value}>{option.label}</option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Active Filters Display */}
//           <div className="mt-4 flex flex-wrap gap-2">
//             {(searchQuery || filters.bookType !== 'all' || filters.language !== 'all') && (
//               <span className="text-sm text-gray-600">Active filters:</span>
//             )}
//             {searchQuery && (
//               <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm rounded-full">
//                 Search: {searchQuery}
//                 <button onClick={() => setSearchQuery('')} className="ml-2 text-blue-600">×</button>
//               </span>
//             )}
//             {filters.bookType !== 'all' && (
//               <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
//                 Type: {filters.bookType}
//                 <button onClick={() => setFilters({ ...filters, bookType: 'all' })} className="ml-2 text-green-600">×</button>
//               </span>
//             )}
//             {filters.language !== 'all' && (
//               <span className="px-3 py-1 bg-purple-100 text-purple-800 text-sm rounded-full">
//                 Language: {filters.language}
//                 <button onClick={() => setFilters({ ...filters, language: 'all' })} className="ml-2 text-purple-600">×</button>
//               </span>
//             )}
//           </div>
//         </div>

//         {/* 3️⃣ E-BOOK LIST TABLE */}
//         <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200">
//             <div className="flex justify-between items-center">
//               <h2 className="text-xl font-bold text-gray-800">E-Books List</h2>
//               <span className="text-sm text-gray-600">
//                 Showing {currentBooks.length} of {filteredBooks.length} e-books
//               </span>
//             </div>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200">
//               <thead className="bg-gray-50">
//                 <tr>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cover</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Book Name</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Author</th>
//                   <th className="px 6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Language(s)</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pages</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Discount</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Final Price</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                   <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="bg-white divide-y divide-gray-200">
//                 {currentBooks.map((book) => (
//                   <tr key={book.id} className="hover:bg-gray-50 transition-colors">
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="w-16 h-24 overflow-hidden rounded-lg border border-gray-200">
//                         <img
//                           src={book.coverImage}
//                           alt={book.bookName}
//                           className="w-full h-full object-cover"
//                         />
//                       </div>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div>
//                         <div className="font-medium text-gray-900">{book.bookName}</div>
//                         <div className="text-sm text-gray-500 line-clamp-2 max-w-xs">
//                           {book.description.substring(0, 100)}...
//                         </div>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaUserEdit className="text-gray-400 mr-2" />
//                         <span className="font-medium">{book.authorName}</span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4">
//                       <div className="flex flex-wrap gap-1">
//                         {book.languages.map((lang, index) => (
//                           <span
//                             key={index}
//                             className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
//                           >
//                             {lang}
//                           </span>
//                         ))}
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaFileAlt className="text-gray-400 mr-2" />
//                         <span className="font-medium">{book.totalPages}</span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaRupeeSign className="text-gray-400 mr-1" />
//                         <span className="font-medium">{book.price === 0 ? 'Free' : `₹${book.price}`}</span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaPercentage className="text-gray-400 mr-1" />
//                         <span className={`font-medium ${book.discount > 0 ? 'text-red-600' : 'text-gray-500'}`}>
//                           {book.discount}%
//                         </span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center">
//                         <FaRupeeSign className="text-gray-400 mr-1" />
//                         <span className={`font-bold ${book.bookType === 'Free' ? 'text-green-600' : 'text-gray-900'}`}>
//                           {book.bookType === 'Free' ? 'Free' : `₹${book.finalPrice.toFixed(2)}`}
//                         </span>
//                       </div>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`px-3 py-1 rounded-full text-xs font-medium ${
//                         book.bookType === 'Free' 
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-blue-100 text-blue-800'
//                       }`}>
//                         {book.bookType}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <span className={`px-3 py-1 rounded-full text-xs font-medium ${
//                         book.status === 'Active'
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-red-100 text-red-800'
//                       }`}>
//                         {book.status}
//                       </span>
//                     </td>
//                     <td className="px-6 py-4 whitespace-nowrap">
//                       <div className="flex items-center space-x-2">
//                         <button
//                           onClick={() => handleViewDetails(book)}
//                           className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
//                           title="View Details"
//                         >
//                           <FaEye />
//                         </button>
//                         <button
//                           onClick={() => navigate(`/admin/ebooks/edit/${book.id}`)}
//                           className="p-2 text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors"
//                           title="Edit"
//                         >
//                           <FaEdit />
//                         </button>
//                         <button
//                           onClick={() => setDeleteConfirm(book.id)}
//                           className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//                           title="Delete"
//                         >
//                           <FaTrash />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {currentBooks.length === 0 && (
//               <div className="text-center py-12">
//                 <FaBook className="text-gray-400 text-4xl mx-auto mb-4" />
//                 <h3 className="text-lg font-medium text-gray-900 mb-2">No e-books found</h3>
//                 <p className="text-gray-500">Try adjusting your search or filters</p>
//               </div>
//             )}
//           </div>

//           {/* Pagination */}
//           {filteredBooks.length > 0 && (
//             <div className="px-6 py-4 border-t border-gray-200">
//               {renderPagination()}
//             </div>
//           )}
//         </div>

//         {/* 4️⃣ VIEW DETAILS MODAL */}
//         {viewDetails && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//             <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
//               <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
//                 <h2 className="text-2xl font-bold text-gray-800">E-Book Details</h2>
//                 <button
//                   onClick={() => setViewDetails(null)}
//                   className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                 >
//                   <FaTimes className="text-xl" />
//                 </button>
//               </div>
              
//               <div className="p-6">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                   {/* Left Column - Cover Image and Basic Info */}
//                   <div className="lg:col-span-1">
//                     <div className="mb-6">
//                       <div className="border-2 border-gray-200 rounded-xl overflow-hidden">
//                         <img
//                           src={viewDetails.coverImage}
//                           alt={viewDetails.bookName}
//                           className="w-full h-auto object-cover"
//                         />
//                       </div>
//                     </div>
                    
//                     <div className="space-y-4">
//                       <div className="p-4 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl border border-indigo-100">
//                         <h4 className="font-medium text-gray-700 mb-3">Book Summary</h4>
//                         <div className="space-y-2">
//                           <div className="flex justify-between">
//                             <span className="text-gray-600">Book Type:</span>
//                             <span className={`font-medium ${
//                               viewDetails.bookType === 'Free' ? 'text-green-600' : 'text-blue-600'
//                             }`}>
//                               {viewDetails.bookType}
//                             </span>
//                           </div>
//                           <div className="flex justify-between">
//                             <span className="text-gray-600">Status:</span>
//                             <span className={`px-2 py-1 rounded text-xs font-medium ${
//                               viewDetails.status === 'Active' 
//                                 ? 'bg-green-100 text-green-800'
//                                 : 'bg-red-100 text-red-800'
//                             }`}>
//                               {viewDetails.status}
//                             </span>
//                           </div>
//                           <div className="flex justify-between">
//                             <span className="text-gray-600">Added on:</span>
//                             <span className="font-medium">{new Date(viewDetails.createdAt).toLocaleDateString()}</span>
//                           </div>
//                         </div>
//                       </div>
                      
//                       <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl border border-amber-100">
//                         <h4 className="font-medium text-gray-700 mb-2">Available Languages</h4>
//                         <div className="flex flex-wrap gap-2">
//                           {viewDetails.languages.map((lang, index) => (
//                             <span
//                               key={index}
//                               className="px-3 py-1 bg-white border border-gray-200 rounded-lg text-sm"
//                             >
//                               {lang}
//                             </span>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
                  
//                   {/* Right Column - Details */}
//                   <div className="lg:col-span-2">
//                     <div className="space-y-6">
//                       {/* Book Name and Author */}
//                       <div>
//                         <h3 className="text-2xl font-bold text-gray-800 mb-2">{viewDetails.bookName}</h3>
//                         <p className="text-lg text-gray-600 flex items-center">
//                           <FaUserEdit className="mr-2" />
//                           {viewDetails.authorName}
//                         </p>
//                       </div>
                      
//                       {/* Stats */}
//                       <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//                         <div className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
//                           <div className="text-2xl font-bold text-blue-600">{viewDetails.totalPages}</div>
//                           <div className="text-sm text-gray-600">Total Pages</div>
//                         </div>
//                         <div className="p-4 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-100">
//                           <div className="text-2xl font-bold text-green-600">
//                             {viewDetails.bookType === 'Free' ? 'Free' : `₹${viewDetails.finalPrice.toFixed(2)}`}
//                           </div>
//                           <div className="text-sm text-gray-600">Final Price</div>
//                         </div>
//                         <div className="p-4 bg-gradient-to-br from-red-50 to-pink-50 rounded-xl border border-red-100">
//                           <div className="text-2xl font-bold text-red-600">{viewDetails.discount}%</div>
//                           <div className="text-sm text-gray-600">Discount</div>
//                         </div>
//                         <div className="p-4 bg-gradient-to-br from-purple-50 to-violet-50 rounded-xl border border-purple-100">
//                           <div className="text-2xl font-bold text-purple-600">{viewDetails.languages.length}</div>
//                           <div className="text-sm text-gray-600">Languages</div>
//                         </div>
//                       </div>
                      
//                       {/* Description */}
//                       <div>
//                         <h4 className="text-lg font-semibold text-gray-800 mb-3">Description</h4>
//                         <p className="text-gray-600 bg-gray-50 p-4 rounded-xl">
//                           {viewDetails.description}
//                         </p>
//                       </div>
                      
//                       {/* Table of Contents */}
//                       <div>
//                         <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
//                           <FaList className="mr-2" />
//                           Table of Contents
//                         </h4>
//                         <div className="space-y-2">
//                           {viewDetails.tableOfContents.map((chapter, index) => (
//                             <div key={index} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
//                               <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-indigo-100 text-indigo-600 rounded-full text-xs font-medium">
//                                 {index + 1}
//                               </div>
//                               <span className="text-gray-700">{chapter}</span>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
                      
//                       {/* PDF Files */}
//                       <div>
//                         <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
//                           <FaFilePdf className="mr-2 text-red-500" />
//                           Available PDF Files
//                         </h4>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                           {Object.entries(viewDetails.pdfFiles).map(([lang, filename]) => (
//                             <div key={lang} className="p-3 bg-red-50 border border-red-100 rounded-xl">
//                               <div className="flex items-center">
//                                 <FaFilePdf className="text-red-500 mr-3" />
//                                 <div>
//                                   <div className="font-medium text-gray-800">{filename}</div>
//                                   <div className="text-sm text-gray-600">{lang.charAt(0).toUpperCase() + lang.slice(1)} Version</div>
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
                      
//                       {/* Links */}
//                       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         {viewDetails.playStoreLink && (
//                           <div className="p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-100">
//                             <h5 className="font-medium text-gray-700 mb-2 flex items-center">
//                               <FaGooglePlay className="mr-2 text-green-500" />
//                               Play Store App
//                             </h5>
//                             <a
//                               href={viewDetails.playStoreLink}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="text-sm text-green-600 hover:underline flex items-center"
//                             >
//                               <FaExternalLinkAlt className="mr-1" />
//                               View on Play Store
//                             </a>
//                           </div>
//                         )}
                        
//                         {viewDetails.websiteLink && (
//                           <div className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100">
//                             <h5 className="font-medium text-gray-700 mb-2 flex items-center">
//                               <FaExternalLinkAlt className="mr-2 text-blue-500" />
//                               E-Book Website
//                             </h5>
//                             <a
//                               href={viewDetails.websiteLink}
//                               target="_blank"
//                               rel="noopener noreferrer"
//                               className="text-sm text-blue-600 hover:underline flex items-center"
//                             >
//                               <FaExternalLinkAlt className="mr-1" />
//                               Visit Website
//                             </a>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="border-t border-gray-200 px-6 py-4 flex justify-end">
//                 <button
//                   onClick={() => setViewDetails(null)}
//                   className="px-6 py-2 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200 transition-colors"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 5️⃣ DELETE CONFIRMATION MODAL */}
//         {deleteConfirm && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//             <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
//               <div className="p-6">
//                 <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
//                   <FaTrash className="text-2xl text-red-600" />
//                 </div>
                
//                 <h3 className="text-xl font-bold text-gray-800 text-center mb-2">
//                   Delete E-Book
//                 </h3>
                
//                 <p className="text-gray-600 text-center mb-6">
//                   Are you sure you want to delete this e-book? This action cannot be undone.
//                 </p>
                
//                 <div className="flex space-x-3">
//                   <button
//                     onClick={() => setDeleteConfirm(null)}
//                     className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={() => handleDeleteBook(deleteConfirm)}
//                     className="flex-1 px-4 py-3 bg-gradient-to-r from-red-600 to-pink-600 text-white font-medium rounded-xl hover:from-red-700 hover:to-pink-700 transition-colors"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminViewBook;


import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  FaBook, FaSearch, FaFilter, FaSortAmountDown, FaPlus, FaEye, FaEdit, FaTrash,
  FaFilePdf, FaGlobe, FaRupeeSign, FaPercentage, FaUserEdit, FaTimes,
  FaChevronLeft, FaChevronRight, FaFileAlt, FaList, FaLanguage, FaCalendar,
  FaExternalLinkAlt, FaGooglePlay, FaCheckCircle, FaTimesCircle
} from 'react-icons/fa';

// Firebase imports
import { database, storage } from '../firebase';
import { ref as dbRef, onValue, remove } from 'firebase/database';
import { ref as storageRef, deleteObject } from 'firebase/storage';

const AdminViewBook = () => {
  const navigate = useNavigate();

  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [searchQuery, setSearchQuery] = useState('');
  const [searchType, setSearchType] = useState('bookName');
  const [filters, setFilters] = useState({
    bookType: 'all',
    language: 'all',
    sortBy: 'latest'
  });

  const [viewDetails, setViewDetails] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const bookTypes = ['All', 'Free', 'Paid'];
  const languages = ['All', 'English', 'Marathi', 'Hindi', 'Other'];
  const sortOptions = [
    { value: 'latest', label: 'Latest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'price_low', label: 'Price: Low to High' },
    { value: 'price_high', label: 'Price: High to Low' },
    { value: 'name_asc', label: 'Name: A to Z' },
    { value: 'name_desc', label: 'Name: Z to A' }
  ];

  // Fetch all e-books from Firebase
  useEffect(() => {
    const ebooksRef = dbRef(database, 'Dr/eBooks');

    const unsubscribe = onValue(ebooksRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const ebooksList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setBooks(ebooksList);
      } else {
        setBooks([]);
      }
      setLoading(false);
    }, (error) => {
      console.error('Error fetching e-books:', error);
      setError('Failed to load e-books. Please try again.');
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Filter and sort books
  const filteredBooks = books.filter(book => {
    if (searchQuery) {
      if (searchType === 'bookName' && !book.bookName?.toLowerCase().includes(searchQuery.toLowerCase())) return false;
      if (searchType === 'authorName' && !book.authorName?.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    }

    if (filters.bookType !== 'all' && book.bookType !== filters.bookType) return false;

    if (filters.language !== 'all') {
      const availableLangs = Object.keys(book.pdfUrls || {});
      if (!availableLangs.includes(filters.language.toLowerCase())) return false;
    }

    return true;
  }).sort((a, b) => {
    switch (filters.sortBy) {
      case 'latest':
        return new Date(b.createdAt || 0) - new Date(a.createdAt || 0);
      case 'oldest':
        return new Date(a.createdAt || 0) - new Date(b.createdAt || 0);
      case 'price_low':
        return (a.discountedPrice || 0) - (b.discountedPrice || 0);
      case 'price_high':
        return (b.discountedPrice || 0) - (a.discountedPrice || 0);
      case 'name_asc':
        return a.bookName.localeCompare(b.bookName);
      case 'name_desc':
        return b.bookName.localeCompare(a.bookName);
      default:
        return 0;
    }
  });

  // Pagination
  const indexOfLastBook = currentPage * itemsPerPage;
  const indexOfFirstBook = indexOfLastBook - itemsPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);
  const totalPages = Math.ceil(filteredBooks.length / itemsPerPage);

  const handlePageChange = (page) => setCurrentPage(page);

  // Delete e-book (from database + storage)
  const handleDeleteBook = async (ebookId) => {
    try {
      const book = books.find(b => b.id === ebookId);
      if (!book) return;

      // Delete cover image
      if (book.coverUrl) {
        const coverRef = storageRef(storage, `Dr/eBooks/${ebookId}/cover.jpg`);
        await deleteObject(coverRef).catch(() => {});
      }

      // Delete all PDFs
      if (book.pdfUrls) {
        for (const lang in book.pdfUrls) {
          const pdfRef = storageRef(storage, `Dr/eBooks/${ebookId}/pdfs/${lang}.pdf`);
          await deleteObject(pdfRef).catch(() => {});
        }
      }

      // Delete database entry
      const ebookRef = dbRef(database, `Dr/eBooks/${ebookId}`);
      await remove(ebookRef);

      setSuccessMessage('E-Book deleted successfully!');
      setDeleteConfirm(null);
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Delete failed:', err);
      setError('Failed to delete e-book. Try again.');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading e-books...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-800">Manage E-Books</h1>
              <p className="text-gray-600 mt-2">View, edit, and manage all published e-books</p>
            </div>
            <Link
              to="/admin/add-ebook"
              className="mt-4 sm:mt-0 inline-flex items-center px-5 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 text-white font-medium rounded-xl hover:shadow-lg"
            >
              <FaPlus className="mr-2" /> Add New E-Book
            </Link>
          </div>
        </div>

        {/* Messages */}
        {successMessage && (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl flex items-center">
            <FaCheckCircle className="text-green-600 text-xl mr-3" />
            <p className="font-bold text-green-800">{successMessage}</p>
          </div>
        )}

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl flex items-center">
            <FaTimesCircle className="text-red-600 text-xl mr-3" />
            <p className="font-bold text-red-800">{error}</p>
          </div>
        )}

        {/* Search & Filters */}
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Search by:</label>
              <div className="flex space-x-2">
                <select value={searchType} onChange={(e) => setSearchType(e.target.value)}
                  className="border rounded-lg px-3 py-2">
                  <option value="bookName">Book Name</option>
                  <option value="authorName">Author Name</option>
                </select>
                <div className="relative flex-1">
                  <FaSearch className="absolute left-3 top-3 text-gray-400" />
                  <input
                    type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search..." className="pl-10 w-full p-2 border rounded-lg"
                  />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Book Type</label>
              <select value={filters.bookType} onChange={(e) => setFilters({ ...filters, bookType: e.target.value })}
                className="w-full p-2 border rounded-lg">
                {bookTypes.map(t => <option key={t} value={t.toLowerCase()}>{t}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Language</label>
              <select value={filters.language} onChange={(e) => setFilters({ ...filters, language: e.target.value })}
                className="w-full p-2 border rounded-lg">
                {languages.map(l => <option key={l} value={l.toLowerCase()}>{l}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Sort by</label>
              <select value={filters.sortBy} onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}
                className="w-full p-2 border rounded-lg">
                {sortOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="px-6 py-4 border-b">
            <h2 className="text-xl font-bold">E-Books List ({filteredBooks.length})</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cover</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Title</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Author</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lang</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pages</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Price</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {currentBooks.map((book) => (
                  <tr key={book.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <img src={book.coverUrl} alt={book.bookName} className="w-16 h-24 object-cover rounded-lg border" />
                    </td>
                    <td className="px-6 py-4">
                      <div className="font-medium">{book.bookName}</div>
                      <div className="text-sm text-gray-500">Code: {book.bookCode}</div>
                    </td>
                    <td className="px-6 py-4">{book.authorName}</td>
                    <td className="px-6 py-4">
                      <div className="flex gap-1 flex-wrap">
                        {Object.keys(book.pdfUrls || {}).map(lang => (
                          <span key={lang} className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded">
                            {lang.charAt(0).toUpperCase() + lang.slice(1)}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">{book.totalPages}</td>
                    <td className="px-6 py-4">
                      {book.bookType === 'Free' ? (
                        <span className="text-green-600 font-bold">Free</span>
                      ) : (
                        <div>
                          <div className="font-bold">₹{book.discountedPrice?.toFixed(2)}</div>
                          {book.discountValue > 0 && <div className="text-sm text-gray-500 line-through">₹{book.bookPrice}</div>}
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${book.bookType === 'Free' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {book.bookType}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${book.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {book.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <button onClick={() => setViewDetails(book)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg"><FaEye /></button>
                        <button onClick={() => navigate(`/admin/ebooks/edit/${book.id}`)} className="p-2 text-yellow-600 hover:bg-yellow-50 rounded-lg"><FaEdit /></button>
                        <button onClick={() => setDeleteConfirm(book.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg"><FaTrash /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {currentBooks.length === 0 && (
              <div className="text-center py-12 text-gray-500">
                <FaBook className="text-4xl mx-auto mb-3 text-gray-300" />
                <p>No e-books found matching your filters.</p>
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="px-6 py-4 border-t flex justify-center gap-2">
              <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                className="p-2 border rounded-lg disabled:opacity-50"><FaChevronLeft /></button>
              {[...Array(totalPages)].map((_, i) => (
                <button key={i+1} onClick={() => handlePageChange(i+1)}
                  className={`w-10 h-10 rounded-lg ${currentPage === i+1 ? 'bg-teal-600 text-white' : 'border hover:bg-gray-50'}`}>
                  {i+1}
                </button>
              ))}
              <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                className="p-2 border rounded-lg disabled:opacity-50"><FaChevronRight /></button>
            </div>
          )}
        </div>

        {/* View Details Modal */}
        {viewDetails && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={() => setViewDetails(null)}>
            <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
              <div className="p-6 border-b flex justify-between items-center">
                <h2 className="text-2xl font-bold">E-Book Details</h2>
                <button onClick={() => setViewDetails(null)}><FaTimes className="text-xl" /></button>
              </div>
              <div className="p-6 grid lg:grid-cols-3 gap-8">
                <div>
                  <img src={viewDetails.coverUrl} alt="" className="w-full rounded-xl border" />
                  <div className="mt-6 space-y-3 text-sm">
                    <div><strong>Code:</strong> {viewDetails.bookCode}</div>
                    <div><strong>Status:</strong> <span className={viewDetails.isActive ? 'text-green-600' : 'text-red-600'}>{viewDetails.status}</span></div>
                    <div><strong>Added:</strong> {new Date(viewDetails.createdAt).toLocaleDateString()}</div>
                  </div>
                </div>
                <div className="lg:col-span-2 space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold">{viewDetails.bookName}</h3>
                    <p className="text-gray-600 flex items-center mt-1"><FaUserEdit className="mr-2" />{viewDetails.authorName}</p>
                  </div>
                  <p className="text-gray-700">{viewDetails.description}</p>

                  {viewDetails.tableOfContents?.length > 0 && (
                    <div>
                      <h4 className="font-bold mb-3 flex items-center"><FaList className="mr-2" />Table of Contents</h4>
                      <ol className="space-y-2">
                        {viewDetails.tableOfContents.map((ch, i) => (
                          <li key={i} className="flex items-start gap-3">
                            <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 text-indigo-700 rounded-full flex items-center justify-center text-xs">{i+1}</span>
                            <span>{ch}</span>
                          </li>
                        ))}
                      </ol>
                    </div>
                  )}

                  <div>
                    <h4 className="font-bold mb-3">Available PDFs</h4>
                    <div className="grid grid-cols-2 gap-3">
                      {Object.entries(viewDetails.pdfUrls || {}).map(([lang, url]) => (
                        <a key={lang} href={url} target="_blank" rel="noopener noreferrer"
                          className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3 hover:bg-red-100">
                          <FaFilePdf className="text-red-600" />
                          <span className="capitalize">{lang} Version</span>
                        </a>
                      ))}
                    </div>
                  </div>

                  {(viewDetails.playStoreLink) && (
                    <div className="flex gap-4">
                      {viewDetails.playStoreLink && (
                        <a href={viewDetails.playStoreLink} target="_blank" className="flex items-center text-green-600 hover:underline">
                          <FaGooglePlay className="mr-2" /> Play Store
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation */}
        {deleteConfirm && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-6 max-w-md">
              <h3 className="text-xl font-bold mb-4">Confirm Delete</h3>
              <p>Are you sure you want to delete this e-book? This action cannot be undone.</p>
              <div className="flex gap-3 mt-6">
                <button onClick={() => setDeleteConfirm(null)} className="flex-1 py-2 border rounded-xl">Cancel</button>
                <button onClick={() => handleDeleteBook(deleteConfirm)} className="flex-1 py-2 bg-red-600 text-white rounded-xl">Delete</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminViewBook;

